import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../assets/icons/dots-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-748b429c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "editor",
  class: "blocks-wrapper"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onMouseover", "onMouseout"]
const _hoisted_5 = {
  key: 0,
  class: "actions-wrapper d-flex align-items-center"
}
const _hoisted_6 = { class: "actions d-flex" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "dots",
  width: "15",
  class: "drag-icon cursor-pointer"
}, null, -1))
const _hoisted_8 = ["id"]
const _hoisted_9 = {
  key: 0,
  class: "float-end"
}
const _hoisted_10 = { class: "position-relative" }
const _hoisted_11 = {
  "data-bs-toggle": "modal",
  "data-bs-target": "#deleteBlockModal"
}
const _hoisted_12 = {
  type: "button",
  "data-bs-toggle": "offcanvas",
  "data-bs-target": "#taskSidebar",
  ref: "openModal"
}
const _hoisted_13 = {
  type: "button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#selectTaskType",
  ref: "openSelectTaskTypeModal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_spinner = _resolveComponent("loading-spinner")!
  const _component_add_menu = _resolveComponent("add-menu")!
  const _component_feather_icon = _resolveComponent("feather-icon")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_delete_block_modal = _resolveComponent("delete-block-modal")!
  const _component_add_form_modal = _resolveComponent("add-form-modal")!
  const _component_filestack_add_image_modal = _resolveComponent("filestack-add-image-modal")!
  const _component_calendar_modal = _resolveComponent("calendar-modal")!
  const _component_video_url_modal = _resolveComponent("video-url-modal")!
  const _component_single_field_form_modal = _resolveComponent("single-field-form-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.moduleLoaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_loading_spinner)
        ]))
      : _createCommentVNode("", true),
    (_ctx.moduleLoaded)
      ? (_openBlock(), _createBlock(_component_draggable, {
          key: 1,
          modelValue: _ctx.computedBlocks,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.computedBlocks) = $event)),
          group: "blocks",
          "item-key": "blockId",
          handle: ".drag-icon",
          onStart: _cache[2] || (_cache[2] = ($event: any) => (_ctx.drag = true)),
          onEnd: _cache[3] || (_cache[3] = ($event: any) => (_ctx.drag = false)),
          class: "mt-2 mb-2"
        }, {
          item: _withCtx(({ element }) => [
            _createElementVNode("div", {
              onClick: ($event: any) => (_ctx.selectedBlock = element)
            }, [
              _createElementVNode("div", {
                class: "d-flex savespace align-items-stretch",
                onMouseover: ($event: any) => (_ctx.showAction(element.blockId)),
                onMouseout: ($event: any) => (_ctx.closeAction(element.blockId))
              }, [
                (_ctx.showActions[element.blockId])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _createVNode(_component_add_menu, {
                          onAddBlock: ($event: any) => (_ctx.addBlock($event.type, element.weight, $event.content)),
                          onTmpBlock: ($event: any) => {_ctx.tmpBlock = $event; _ctx.tmpBlock.weight = element.weight},
                          onSetDelay: _cache[0] || (_cache[0] = (value) => _ctx.delay = value),
                          onOpenFilestack: _ctx.handleFilestackOpen,
                          onAddTask: _ctx.openSelectTaskTypeModal
                        }, null, 8, ["onAddBlock", "onTmpBlock", "onOpenFilestack", "onAddTask"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(), _createElementBlock("div", {
                  class: "block ms-2",
                  key: _ctx.refreshTimestamp,
                  id: element.blockId
                }, [
                  (_ctx.showDebugHelpers)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_9, _toDisplayString(element.weight), 1))
                    : _createCommentVNode("", true),
                  (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.typeComponent(element.type)), {
                    content: element.content,
                    "onUpdate:content": [($event: any) => ((element.content) = $event), ($event: any) => (_ctx.updateBlock(element, $event))],
                    blockId: element.blockId,
                    moduleId: element.moduleId,
                    isTemplate: _ctx.isTemplate
                  }, null, 40, ["content", "onUpdate:content", "blockId", "moduleId", "isTemplate"]))
                ], 8, _hoisted_8)),
                _withDirectives(_createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_feather_icon, {
                      type: "trash",
                      class: "cursor-pointer position-absolute mt-3",
                      size: "15",
                      stroke: "#1F3245"
                    })
                  ])
                ], 512), [
                  [_vShow, _ctx.showActions[element.blockId]]
                ])
              ], 40, _hoisted_4)
            ], 8, _hoisted_3)
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.selectedBlock)
      ? (_openBlock(), _createBlock(_component_delete_block_modal, {
          key: 2,
          block: _ctx.selectedBlock
        }, null, 8, ["block"]))
      : _createCommentVNode("", true),
    _createVNode(_component_add_form_modal, {
      tmpBlock: _ctx.tmpBlock,
      onAddBlock: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addBlock('taskLink', $event.weight, $event.content)))
    }, null, 8, ["tmpBlock"]),
    (_ctx.setFilestackOpen)
      ? (_openBlock(), _createBlock(_component_filestack_add_image_modal, {
          key: 3,
          apikey: _ctx.apiKey,
          onError: _ctx.onFilestackError,
          handleSuccess: _ctx.onFilestackSuccess,
          isFilestackOpen: _ctx.setFilestackOpen,
          accept: _ctx.fileStackOptions.accept,
          allowConcurrent: _ctx.fileStackOptions.allowConcurrent,
          onClosed: () => _ctx.setFilestackOpen = false
        }, null, 8, ["apikey", "onError", "handleSuccess", "isFilestackOpen", "accept", "allowConcurrent", "onClosed"]))
      : _createCommentVNode("", true),
    _createVNode(_component_calendar_modal, {
      tmpBlock: _ctx.tmpBlock,
      onSubmit: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addBlock('task', $event.weight, $event))),
      onAddBlock: _cache[6] || (_cache[6] = ($event: any) => (_ctx.addBlock('taskLink', $event.weight, $event.content)))
    }, null, 8, ["tmpBlock"]),
    _createVNode(_component_video_url_modal, {
      tmpBlock: _ctx.tmpBlock,
      onSubmit: _cache[7] || (_cache[7] = ($event: any) => (_ctx.addBlock('video', $event.weight, $event)))
    }, null, 8, ["tmpBlock"]),
    _createVNode(_component_single_field_form_modal, {
      tmpBlock: _ctx.tmpBlock,
      onSubmit: _cache[8] || (_cache[8] = ($event: any) => (_ctx.addBlock('task', $event.weight, $event)))
    }, null, 8, ["tmpBlock"]),
    _withDirectives(_createElementVNode("button", _hoisted_12, "Open", 512), [
      [_vShow, false]
    ]),
    _withDirectives(_createElementVNode("button", _hoisted_13, "Open", 512), [
      [_vShow, false]
    ])
  ], 512))
}